import { Plus, X } from "@phosphor-icons/react";
import { Button, Flex, IconButton, Text } from "@radix-ui/themes";

import { isMeaningfulGigsRole } from "../../../utils/auth";
import { type TicketMessageCitation } from "../utils/commentSourceUtils";
import { citationLabel, removeCitationAt } from "../utils/commentSourceUtils";

export function CommentSourceAttachment({
  citations,
  onCitationsChange,
  hasContextAssets,
  onStartContextSourcePlacement,
  disabled = false,
  compact = false,
}: {
  citations: TicketMessageCitation[];
  onCitationsChange: (citations: TicketMessageCitation[]) => void;
  hasContextAssets: boolean;
  onStartContextSourcePlacement?: (
    onPinComplete?: (citation: TicketMessageCitation) => void,
  ) => void;
  disabled?: boolean;
  compact?: boolean;
}) {
  if (!isMeaningfulGigsRole()) return null;
  if (!hasContextAssets && citations.length === 0) return null;

  const canAddSource =
    hasContextAssets && citations.length === 0 && onStartContextSourcePlacement;

  return (
    <Flex direction="column" gap="2" className="shrink-0">
      {citations.length > 0 ? (
        <Flex gap="2" wrap="wrap" data-testid="comment-source-chips">
          {citations.map((citation, index) => (
            <Flex
              key={`source-chip-${index}`}
              align="center"
              gap="1"
              className="rounded-full border border-puntt-neutral-gray-6 bg-puntt-neutral-gray-2 px-2 py-0.5"
            >
              <Text size="1" className="max-w-48 truncate">
                {citationLabel(citation)}
              </Text>
              <IconButton
                size="1"
                variant="ghost"
                color="gray"
                aria-label="Remove source"
                data-testid={`comment-source-remove-${index}`}
                disabled={disabled}
                onClick={() =>
                  onCitationsChange(removeCitationAt(citations, index))
                }
              >
                <X size={12} aria-hidden="true" />
              </IconButton>
            </Flex>
          ))}
        </Flex>
      ) : null}

      {canAddSource ? (
        <Button
          type="button"
          size={compact ? "1" : "2"}
          variant="soft"
          color="gray"
          disabled={disabled}
          data-testid="comment-add-source"
          onClick={() => onStartContextSourcePlacement()}
        >
          <Plus size={14} aria-hidden="true" />
          Add source
        </Button>
      ) : null}
    </Flex>
  );
}
